import {
  AddByManagerActionTypes,
  AddByManagerState,
  ADD_BY_MANAGER_FAILURE,
  ADD_BY_MANAGER_REQUEST,
  ADD_BY_MANAGER_SUCCESS,
} from 'store/reducers/lodgingRequest/addByManager/types';

const defaultState: AddByManagerState = {
  isLoading: false,
  errorMessage: '',
};

export default function addByManager(
  state = defaultState,
  action: AddByManagerActionTypes
): AddByManagerState {
  switch (action.type) {
    case ADD_BY_MANAGER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_BY_MANAGER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: '',
      };
    case ADD_BY_MANAGER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}
